import React from 'react';
import { CurriculumActivities } from '../components/LearnEarn/CurriculumActivities';

const CurriculumPage = () => {
  return <CurriculumActivities />;
};

export default CurriculumPage;
